<template>
	<div id="resetPassword" class="contentLogin">
		<div :class="[isMobile ? 'modLogin mobile' : 'modLogin']">
			<div class="p-3 mb-5 mt-4 bg-white rounded-2 box-shadow fw-500">

				<div class="logo-login">
					<img src="~@/assets/img/logo-fundo-transparente.svg">
					<h1 class="ml-3 mr-3">{{title}}</h1>
				</div>

				<form id="form_reset_password" name="form_reset_password" v-on:submit.prevent="onSubmit">
					<InputUsername />

					<div class="row mt-5">
						<div class="col-2"></div>
						<div class="col-10"><p class="fw-500">{{$t('login_your_password_must_contain')}}</p></div>
					</div>

					<div v-for="element in passwordMustContain">
						<div class="row">
							<div class="col-2"></div>
							<div class="col-1">
								<i v-if="element.valid" class="icon-position icon-ok-green mr-4" />
								<i v-else class="icon-position icon-no-ok-gray mr-4" />
							</div>
							<div class="col-9">
								<p class="fw-400">
									{{element.label}}
								</p>
							</div>
						</div>
					</div>

					<InputPassword @update:updatePassword="updatePassword"/>
					<InputConfirmPassword @update:updateConfirmPassword="updateConfirmPassword"/>
					<InputOtp class="mt-n4 mb-2" :numInputs="6" :label="$t('login_gtoken_ph')" @update:updateToken="updateToken"/>

					<div class="row mt-4 mb-4">
						<div class="col-2"></div>
						<div class="col-8">
							<input
								type="submit"
								:class="buttonEnabled()"
								id="btn_reset_password"
								:value="btnLabel"
								@click="resetPassword()"
								:disabled="disabled"
							>
						</div>
						<div class="col-2"></div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import InputUsername from './composables/InputUsername.vue';
import InputPassword from './composables/InputPassword.vue';
import InputConfirmPassword from './composables/InputConfirmPassword.vue';
import InputOtp from './composables/InputOtp.vue';

import loginControl from '@/mixins/Login/loginControl';
import isMobileControl from '@/mixins/Login/isMobileControl';

export default {
	name: 'ResetPassword',

	mixins: [
		loginControl,
		isMobileControl
	],

	components: {
		InputUsername,
		InputPassword,
		InputConfirmPassword,
		InputOtp
	},

	data (){
		return {
			btnLabel: '',
			title: null,
			username: null,
			password: null,
			password_confirm: null,
			password_temp: null,
			code_access: null,
			tokens: null,
            passwordMustContain: [
				{
					key: 'characters',
                    label: this.$t('login_8_characters'),
					valid: false,
                },
				{
					key: 'lowercase',
                    label: this.$t('login_lowercase'),
					valid: false,
                },
				{
					key: 'capital_letters',
                    label: this.$t('login_capital_letters'),
					valid: false,
                },
				{
					key: 'special_character',
                    label: this.$t('login_special_character'),
					valid: false,
                },
				{
					key: 'numbers',
					label: this.$t('login_numbers'),
					valid: false
				},
			],
			disabled: true
		}
	},

	watch: {
		password(){
			this.disabled = true;

			//Verifica cada item para o password valido
			this.validatePasswordMustContain();

			///Se atende todos os requisitos do password, habilita o botão
			if (this.validateIfPasswordContainsAllRules()) {
				this.disabled = false;
			}
		},

		tokens() {
			if (this.tokens.length == 6) {
				this.disabled = false;

				this.$nextTick(() => {
					this.focus("btn_reset_password");
				});
			}
		},
	},

	created(){
		this.title = this.$route.params.title;
		this.btnLabel = this.$route.params.btnLabel;
		this.username = this.$route.params.username;
		this.password_temp = this.$route.params.password;
		this.code_access = this.$route.params.codeAccess;
		this.tokens = null;

		//Se o code_access for nulo, é primeiro acesso
		if (
			(typeof this.code_access == "undefined" && this.code_access == null) &&
			((typeof this.username == "undefined" && this.username == null) ||
			(typeof this.password_temp == "undefined" && this.password_temp == null))
		) {
			this.toFirstAccess();
		}

		// Coloca o foco inicial no campo password
		if (this.password == null || this.password == '') {
			this.$nextTick(() => {
				this.focus("passwordref");
			});
		}

		this.setLanguage();
	},
}
</script>

<style lang="scss" scoped>
	::v-deep .modLogin::-webkit-scrollbar {
		width: 12px; // Largura da barra de rolagem (https://developer.mozilla.org/pt-BR/docs/Web/CSS/::-webkit-scrollbar)
	}

	::v-deep .modLogin::-webkit-scrollbar-thumb {
		background-color: transparent; // Cor do polegar da barra de rolagem (https://developer.mozilla.org/pt-BR/docs/Web/CSS/::-webkit-scrollbar)
	}

	::v-deep .modLogin::-webkit-scrollbar-track {
		background-color: transparent; // Cor da trilha da barra de rolagem (https://developer.mozilla.org/pt-BR/docs/Web/CSS/::-webkit-scrollbar)
	}
</style>
